import type { RefObject } from "react"
//import { utils, writeFileXLSX } from "xlsx"
import saveFile from "save-file"

export function DownloadTableAsXls({ tableContainerRef, fileName }: {
	tableContainerRef: RefObject<HTMLDivElement | null>,
	fileName: string
}) {
	const handleDownloadXLSClick = async () => {

		if(!tableContainerRef.current) return

		const tableElements = tableContainerRef.current.getElementsByTagName("table")

		/*if(tableElements.length !== 1){
			console.error("tableContainerRef должен содержать один элемент <table>")
			return
		}

		const worksheet = utils.table_to_sheet(tableElements[0])
		const workbook = utils.book_new()
		utils.book_append_sheet(workbook, worksheet, fileName)
		writeFileXLSX(workbook, fileName + '.xlsx')*/

		const html = tableElements[0]
			?.outerHTML
			?.replace(/<table[^>]+>/, "<table border=\"1\">") ?? ""

		await saveFile(
			new Blob([html]),
			fileName + ".xls"
		)
	}

	return <div className="flex items-center gap-[1rem]">
		<span>Скачать XLS: </span>
		<img
			title="Скачать XLS"
			src="https://public.kemsu.ru/icons/excel.jpg"
			style={{ cursor: "pointer" }}
			onClick={handleDownloadXLSClick}
		/>
	</div>
}